import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { home, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!home) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && home.role !== 'admin') {
    return <Navigate to="/manager/dashboard" />;
  }

  return children;
};

export default PrivateRoute;
